module.exports = {
      id: "group-usage",
      viewBox: "0 0 11 10",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#group",
      toString: function () {
        return this.url;
      }
    }